import { Request } from "./request";
import { API_PREFIX } from "./constant";

export interface DoctorAchievementParams {
//   drugType?: number;
  timeHead?: string;
  timeTail?: string;
}

export function getDoctorAchievement(
  params: DoctorAchievementParams
): Request {
  return {
    url: `${API_PREFIX}/blade-outpatient/statistics/doctorPerformanceList`,
    method: "GET",
    params,
  };
}

export function getDoctorAchievementExport(
  params: DoctorAchievementParams
): Request {
  return {
    url: `${API_PREFIX}/blade-outpatient/statistics/doctorPerformanceList/exportexcel`,
    method: 'GET',
    responseType: 'blob',
    params,
  }
}
